import { Building, Scan, Briefcase, TrendingUp } from 'lucide-react';
const IntelligenceScanner = ({ intelligenceCategories, setSelectedIntelCategory }: any) => {
    return (
        <div className="space-y-4">
            {intelligenceCategories.map((category: any) => (
                <div key={category.id} className='bg-white p-[25px] rounded-[5px] shadow-2xl cursor-pointer hover:bg-slate-50' onClick={() => setSelectedIntelCategory(category)}>
                    <div>
                        <div className="text-lg flex items-center gap-2">
                            {category.id === "startups" && <Building className="w-4 h-4" />}
                            {category.id === "funding" && <TrendingUp className="w-4 h-4" />}
                            {category.id === "jobMoves" && <Briefcase className="w-4 h-4" />}
                            {category.id === "ipSearch" && <Scan className="w-4 h-4" />}
                            <span className='font-bold'>{category.name}</span>
                        </div>
                        <div>{category.description}</div>
                    </div>
                    <div className="text-sm text-gray-500">
                        Source: {category.source} • Updated: {category.frequency}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default IntelligenceScanner